export const TOASTS_TYPE = {
  RELOAD_WEB_PAGE: 'RELOAD_WEB_PAGE',
}
